import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { FACULTY } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/faculty/new")({
  component: () => <DeptContentForm cfg={FACULTY} />,
});
